"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeLogging = void 0;
// import { v4 as uuid } from 'uuid';
// NOTE: using the above package caused Typescript issues when running `npm run dist:cdn`
const uuid = () => Math.random().toString(36).slice(-20);
// import trackyr from '@kyruus/trackyr';
/**
 * TODO this is mostly placeholder code pending a reqrite of trackyr:
 * https://kyruus.jira.com/browse/KENG-27982
 */
const noOp = () => {
    // TODO do nothing, dummy function so this will compile
};
/**
 * Initializes and returns a logging function that wraps trackyr.track. Doing
 * things here the same way they are done in PMC. This SHOULD only get called during
 * machine initializtion for embedded widgets; in Search, the log function is
 * already defined and passed in as a prop
 * @param config Config
 * @returns function
 */
function initializeLogging(config) {
    const userID = uuid();
    const initMetadata = {
        customer_code: config.customer_code,
        // we should only be initializing a log function outside Kyruus (external), so always prd here
        deployment: 'prd',
        product_name: 'search_widget',
        tracking_token: uuid(),
        user_id: userID
    };
    const eventMetadata = {
        customer_id: config.customer_code,
        distinct_id: uuid(),
        search_token: uuid(),
        user_token: userID,
        user_type: 'Anonymous'
    };
    // trackyr.init({
    //   ...initMetadata,
    //   referrer: document.referrer || 'UNKNOWN'
    // });
    const log = (eventName, eventData) => {
        // trackyr.track(eventName, {
        //   ...eventMetadata,
        //   ...eventData
        // });
        /*eslint-disable @typescript-eslint/ban-ts-comment*/
        // @ts-ignore
        noOp(initMetadata, eventMetadata, eventName, eventData);
    };
    return log;
}
exports.initializeLogging = initializeLogging;
//# sourceMappingURL=initializeLogging.js.map